/**
 * Card swatches — oakling
 * Swaps the product card image on swatch tap and updates the card link
 * to point to the matching variant.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('.card-swatches__swatch');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    const cardWrapper = swatch.closest('.card-wrapper');
    if (!cardWrapper) return;

    const newImageUrl = swatch.dataset.imageUrl;
    const newSrcset = swatch.dataset.imageSrcset;
    const newAlt = swatch.dataset.imageAlt;
    const newVariantUrl = swatch.dataset.variantUrl;

    // Swap the primary product image
    const img = cardWrapper.querySelector('.card__media .media img:first-child');
    if (img && newImageUrl) {
      img.src = newImageUrl;
      if (newSrcset) img.srcset = newSrcset;
      if (newAlt) img.alt = newAlt;
    }

    // Update the title link so any click on the card goes to the selected variant
    const titleLink = cardWrapper.querySelector('.card__heading a');
    if (titleLink && newVariantUrl) {
      titleLink.href = newVariantUrl;
    }

    // Visual: mark active swatch within this card
    cardWrapper.querySelectorAll('.card-swatches__swatch').forEach(function (s) {
      s.classList.remove('is-active');
    });
    swatch.classList.add('is-active');
  });
})();